import { render } from "./CompareChart.vue?vue&type=template&id=0fecdce1"
import script from "./CompareChart.vue?vue&type=script&lang=js"
export * from "./CompareChart.vue?vue&type=script&lang=js"

import "./CompareChart.vue?vue&type=style&index=0&id=0fecdce1&lang=scss"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__